<template>
    <el-dialog v-if="equmentDialogVisible" :title="name" custom-class="equment-dialog" top="10vh"
        :visible.sync="equmentDialogVisible" append-to-body @close="hidePop">
        <el-table :data="tableData" border style="width: 100%">
            <el-table-column prop="RecordCompany" label="所属机构" width="150" align="center">
            </el-table-column>
            <el-table-column prop="ElderName" label="姓名" width="100" align="center">
            </el-table-column>
            <el-table-column prop="DataType" label="数据类型" width="80" align="center">
            </el-table-column>
            <el-table-column prop="DeviceType" label="设备类型" width="90" align="center">
            </el-table-column>
            <el-table-column prop="RecordDesc" label="信息" align="center">
            </el-table-column>
            <el-table-column prop="RecordTime" label="时间" width="180" align="center">
            </el-table-column>
        </el-table>
        <el-pagination class="pagination" @current-change="handleCurrentChange" :current-page.sync="pageIndex"
            :page-size="10" layout="total, prev, pager, next" :total="total">
        </el-pagination>
    </el-dialog>
</template>

<script>
import PubSub from 'pubsub-js'
import { mapGetters } from 'vuex'
export default {
    name: 'EqumentDetail',
    computed: {
        ...mapGetters(['cid']),
    },
    data() {
        return {
            equmentDialogVisible: false,
            pageIndex: 1,
            tableData: [],
            total: 0,
            name: '老人的设备信息',
            checkDataId: '',
            deviceType: ''
        }
    },
    watch: {},
    mounted() {
        
        PubSub.subscribe('EqumentDetail', (msg, data) => {
            console.log(data);
            data = data.data
            this.name = data.ElderName + "老人的设备信息"
            this.pageIndex = 1
            this.checkDataId = data.CheckDataId
            this.deviceType = data.LSDevice
            this.getYNDeviceDataRecord(this.checkDataId, this.deviceType, this.pageIndex)
            this.equmentDialogVisible = true
        })
    },
    methods: {
        handleCurrentChange(val) {
            this.pageIndex = val
            this.getYNDeviceDataRecord(this.checkDataId, this.deviceType, this.pageIndex)
        },
        hidePop() {
            this.checkDataId = ''
            this.deviceType = ''
            this.pageIndex = 0
            this.total = 0
            this.tableData = []
        },
        getYNDeviceDataRecord(checkDataId, deviceType, pageIndex) {
            this.$api
                .getYNDeviceDataRecord(checkDataId, deviceType, pageIndex)
                .then((data) => {
                    console.log("-------------------------->ElderDetail");
                    console.log(data)
                    this.tableData = data.list
                    this.total = data.total
                })
                .catch((error) => {
                    console.error(error)
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.pagination {
    margin-top: 10px;
}

.select {
    margin-bottom: 10px;
}

.pop-equment {
    width: 30px;
    height: 30px;
}

.video {
    cursor: pointer;
}
</style>